import { render } from "./Craft.vue?vue&type=template&id=0d494371"
import script from "./Craft.vue?vue&type=script&lang=js"
export * from "./Craft.vue?vue&type=script&lang=js"

import exportComponent from "/Users/abdulmanan/Sites/weapsmithing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__